import React, { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { toast } from 'sonner';
import api from '../../utils/api';
import { getApiErrorMessage } from '../../utils/errorMessage';

const AdminDataHub = () => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [loading, setLoading] = useState('');

  const downloadFile = async (endpoint, filename, type) => {
    try {
      setLoading(endpoint);
      const params = new URLSearchParams();
      if (fromDate) params.append('from_date', fromDate);
      if (toDate) params.append('to_date', toDate);

      const response = await api.get(`${endpoint}?${params.toString()}`, {
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data], { type }));
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast.success('Download started');
    } catch (error) {
      toast.error(getApiErrorMessage(error, 'Failed to download file'));
    } finally {
      setLoading('');
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-amber-950">Data Hub</h1>
        <p className="text-amber-700 mt-1">Business exports: customers/orders, GSTR-1, and bulk invoices ZIP.</p>
      </div>

      <div className="bg-white border-2 border-amber-200 rounded-2xl p-6 shadow-sm">
        <h2 className="text-lg font-semibold text-amber-950 mb-4">Filter by Date Range</h2>
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <label className="text-sm text-amber-900">From</label>
            <Input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} className="mt-1 border-amber-200" />
          </div>
          <div>
            <label className="text-sm text-amber-900">To</label>
            <Input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} className="mt-1 border-amber-200" />
          </div>
        </div>
      </div>

      <div className="bg-white border-2 border-amber-200 rounded-2xl p-6 shadow-sm space-y-4">
        <Button
          onClick={() => downloadFile('/admin/data/export/customers-orders.csv', 'customers_orders.csv', 'text/csv')}
          disabled={loading !== ''}
          className="w-full bg-amber-600 hover:bg-amber-700 text-white"
        >
          {loading === '/admin/data/export/customers-orders.csv' ? 'Preparing...' : 'Export Customer + Order CSV'}
        </Button>

        <Button
          onClick={() => downloadFile('/admin/data/export/gstr1.csv', 'gstr1.csv', 'text/csv')}
          disabled={loading !== ''}
          className="w-full bg-amber-700 hover:bg-amber-800 text-white"
        >
          {loading === '/admin/data/export/gstr1.csv' ? 'Preparing...' : 'Export GSTR-1 CSV (POS + Tax Slab)'}
        </Button>

        <Button
          onClick={() => downloadFile('/admin/data/export/invoices.zip', 'invoices.zip', 'application/zip')}
          disabled={loading !== ''}
          className="w-full bg-orange-600 hover:bg-orange-700 text-white"
        >
          {loading === '/admin/data/export/invoices.zip' ? 'Preparing...' : 'Download Bulk Invoices ZIP'}
        </Button>
      </div>
    </div>
  );
};

export default AdminDataHub;
